module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "href": _vm.post && _vm.post.permalink,
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.post ? (_vm.post.media_type === 'VIDEO' ? _vm.post.thumbnail_url : _vm.post.media_url) : null,
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.post && _vm.post.caption ? _vm.post.caption.substring(0, 25) : '') + "... ")]), _vm._v(" "), _c('v-card-actions', [_c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.isSelected ? 'primary' : 'red',
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [(_vm.isSelected) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]) : _vm._e(), _vm._v(" "), (!_vm.isSelected) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close-circle")]) : _vm._e()], 1), _vm._v("\n      " + _vm._s(_vm.post && _vm.post.isStory ? 'Story' : 'Post') + "\n    ")], 1), _vm._v(" "), (!_vm.isSelected) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('selected')
      }
    }
  }, [_vm._v("\n      Select\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.post ? _vm.post.caption : '') + "\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-568e2c42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/Post.vue
// module id = 2134
// module chunks = 0